import { Result } from './model';
export var asArray = function (sanitizer) {
    return function (value, path) {
        if (!Array.isArray(value)) {
            return Result.error([{ path: path, expected: 'array' }]);
        }
        var results = [];
        var errors = [];
        for (var i = 0; i < value.length; i++) {
            var result = sanitizer(value[i], path + "[" + i + "]");
            if (Result.isOk(result)) {
                results.push(result.ok);
            }
            else {
                errors.push.apply(errors, result.error);
            }
        }
        return errors.length > 0
            ? Result.error(errors)
            : Result.ok(results);
    };
};
